import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsNotepad = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.down('lg'));
};
export { useIsNotepad };
